module.exports = require('./toPairsIn');